import {
  EActionType,
  IDailyRentOfferForMobileSite,
} from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

export enum EButtonGroupType {
  CIAN_OFFER_DESKTOP,
  PARTNER_OFFER_DESKTOP,
  CIAN_OFFER_DESKTOP_ONLINE_BOOKING,
  CIAN_OFFER_MOBILE_ONLINE_BOOKING,
  CIAN_OFFER_MOBILE,
  PARTNER_OFFER_MOBILE,
  ONLY_CHAT,
}

export interface IGetButtonGroupType {
  offer: Pick<IDailyRentOfferForMobileSite, 'actionType'>;
  deviceType: 'phone' | 'tablet' | 'desktop';
  isDailyrentOnlineBookingEnabled?: boolean;
}

export const getButtonGroupType = ({
  offer,
  deviceType,
  isDailyrentOnlineBookingEnabled = false,
}: IGetButtonGroupType): EButtonGroupType => {
  const isCianPartner = [EActionType.PartnerCheckDates, EActionType.PartnerBooking].includes(offer.actionType);
  const isOnlineBooking = [EActionType.OtaCheckDates, EActionType.OtaBooking].includes(offer.actionType);

  // если открыт десктоп
  if (deviceType === 'desktop') {
    if (isCianPartner) {
      return EButtonGroupType.PARTNER_OFFER_DESKTOP;
    }

    if (isOnlineBooking && isDailyrentOnlineBookingEnabled) {
      return EButtonGroupType.CIAN_OFFER_DESKTOP_ONLINE_BOOKING;
    }

    if (offer.actionType === EActionType.Chat) {
      return EButtonGroupType.ONLY_CHAT;
    }

    return EButtonGroupType.CIAN_OFFER_DESKTOP;
  }

  // если открыт мобвеб
  if (isCianPartner) {
    return EButtonGroupType.PARTNER_OFFER_MOBILE;
  }

  if (isOnlineBooking && isDailyrentOnlineBookingEnabled) {
    return EButtonGroupType.CIAN_OFFER_MOBILE_ONLINE_BOOKING;
  }

  if (offer.actionType === EActionType.Chat) {
    return EButtonGroupType.ONLY_CHAT;
  }

  return EButtonGroupType.CIAN_OFFER_MOBILE;
};
